export default __webpack_public_path__ + "static/media/q2.3244987c.svg";